import React from "react";
import Model from "../Model";
import {
    SideCancelBtn,
    SubmitBtn,
} from "../Styles/InputStyles";
import tw from "tailwind-styled-components";

const DeleteExtraBed = ({
    setIsExtraBedDelete,
    selectedData,
    deleteExtraBedLoading,
    deleteExtraBedMutate,
}) => {

    const handleDeleteExtraBedSubmit = () => {
        deleteExtraBedMutate({
            bedId: selectedData.id,
        });
    };

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setIsExtraBedDelete}
            title={selectedData.isExtraBed === 1 ? "Delete Extra Bed" : "Delete Bed"}
        >
            <WarningText>
                Please confirm you want to delete this {selectedData.isExtraBed === 1 ? "extra bed" : "bed"}.
            </WarningText>
            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsExtraBedDelete(false)}
                >
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    onClick={handleDeleteExtraBedSubmit}
                    disabled={deleteExtraBedLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteExtraBedLoading ? "Loading..." : "Delete"}
                </SubmitBtn>
            </div>
        </Model>
    );
};
const WarningText = tw.p`text-gray-500 text-base mb-4`;
export default DeleteExtraBed;
